
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/[slug]",
      function () {
        return require("private-next-pages/compare/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/[slug]"])
      });
    }
  